import React from 'react';
import PropTypes from 'prop-types';
import Tree from 'components/dynamic-tree';

import AbstractInput from '../abstractInput';

/**
 * === TreeContainer Component ===
 *
 * <TreeContainer
 *   dataBind={dataBind}
 *   dataProvider={url}
 *   itemRenderer={itemRenderer func}
 *   loadOnDemand={false}
 *   updateEvent={update event}
 * />
 */

export default class TreeContainer extends AbstractInput {
  static propTypes = {
    dataProvider: PropTypes.string,
    query: PropTypes.shape({}),
    loadOnDemand: PropTypes.bool,
    onSelect: PropTypes.func,
    itemRenderer: PropTypes.func,
    updateEvent: PropTypes.string,
    multipleSelectionMode: PropTypes.bool,
    treeHeight: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  };

  static defaultProps = {
    treeHeight: 500
  };

  constructor(...props) {
    super(...props);
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect(val) {
    const selectedNodes = this.props.value ? [...this.props.value] : [];
    const index = selectedNodes.indexOf(val.tree);
    if (index === -1) {
      selectedNodes.push(val.tree);
    } else {
      selectedNodes.splice(index, 1);
    }
    this.props.onChange(selectedNodes);
  }

  render() {
    const {
      dataProvider, query,
      itemRenderer, loadOnDemand, updateEvent, multipleSelectionMode, treeHeight,
      value, ...restProps
    } = this.props;

    return (
      <Tree
        {...restProps}
        treeHeight={treeHeight}
        dataProvider={dataProvider}
        query={query}
        itemRenderer={itemRenderer}
        onSelect={this.onSelect}
        loadOnDemand={loadOnDemand}
        selected={value}
        updateEvent={updateEvent}
        multipleSelectionMode={multipleSelectionMode}
      />
    );
  }
}
